export default __webpack_public_path__ + "4682a3692c0492815981930475bb5d9e.svg";